import type { FilterSelection } from '@interfaces/filters/domain';
import type { V2FilterSelection } from '@interfaces/v2Api/filters';

// Post-D1 rename the body is identical to toAnalyticsFilterSelection.
// Kept as a distinct function for call-site grep-ability and to survive
// if the backend ever re-diverges the two surfaces.
export function toSegmentsFilterInput(
  sel: FilterSelection,
): V2FilterSelection {
  if (sel.kind === 'RANGE') {
    return { code: sel.code, range: sel.range };
  }
  return { code: sel.code, options: sel.options };
}

export function toSegmentsFilterInputs(
  sels: FilterSelection[],
): V2FilterSelection[] {
  return sels.map(toSegmentsFilterInput);
}
